<div class="youtube-player-container">
    <div class="curtain cursor-pointer" *ngIf="clickToOpenInDialog" (click)="openDialog()"></div>
    <youtube-player [videoId]="videoId" #player [playerVars]="playerVar" [showBeforeIframeApiLoads]="true"></youtube-player> 
</div>